import React from "react";
import styled, { css } from "styled-components";
import StickyBanner from "src/react/components/sticky-banner";
import { Link } from "src/react/components/link";
import OnTimeRender from "src/react/components/on-time-render";
import { color } from "src/styles/variables";

function BlackFridayBanner({ noLink }) {
  const BannerComponent = noLink ? BannerContainer : BannerLink;
  return (
    <OnTimeRender startDate="2025/11/23 00:00:00" endDate="2025/12/14 23:59:59">
      <StickyBanner backgroundColor={color.black}>
        <BannerComponent to="/gifts">
          <LinkText>
            Black Friday offer - <span>get 20% off all our Gifts!</span>
          </LinkText>
        </BannerComponent>
      </StickyBanner>
    </OnTimeRender>
  );
}

export default BlackFridayBanner;

const bannerStyles = css`
  display: block;
  font-weight: 600;
  text-align: center;
  hyphens: none;
  padding: 10px;
  color: ${color.white};
  :hover {
    color: ${color.white};
  }
`;

const BannerLink = styled(Link)`
  ${bannerStyles}
  span {
    text-decoration: underline;
  }
`;

const BannerContainer = styled.div`
  ${bannerStyles}
`;

const LinkText = styled.p`
  display: inline-block;
  position: relative;
  padding: 0 25px;
  margin-bottom: 0;
`;
